<template>
  <div>
    <md-toolbar
      class="md-primary"
      style="background-color: rgb(44, 105, 188)!important"
      md-elevation="10">
      <router-link to="/dashboard"><img
        src="/static/logo.png"
        alt="ClippFácil"
        style="max-height: 30px; margin: 8px 45px;"></router-link>

      <router-link to="/dashboard"><md-button>Home</md-button></router-link>
      <router-link to="/notas/all"><md-button>Consultar</md-button></router-link>
      <router-link to="/sped"><md-button>Arquivos Fiscais</md-button></router-link>
      <router-link to="/requests"><md-button>Contadores</md-button></router-link>
      <router-link to="/accountant/betaIntegrations"><md-button>Integrações</md-button></router-link>

       <div class="md-toolbar-section-end">
            <md-chip
              md-disabled
              style="color: #fff;">{{ client.businessName }}</md-chip>
            <md-menu
              md-size="big"
              md-direction="bottom-end">
              <md-button
                class="md-icon-button"
                md-menu-trigger>
                <md-icon>account_box</md-icon>
              </md-button>

              <md-menu-content>
                <md-menu-item @click="config">
                  <span>Configurações</span>
                  <md-icon>settings</md-icon>
                </md-menu-item>
                <md-menu-item @click="logout">
                  <span>Sair</span>
                  <md-icon>exit_to_app</md-icon>
                </md-menu-item>
              </md-menu-content>
            </md-menu>
      </div>

    </md-toolbar>
  </div>
</template>

<script>
import { http } from '../../public/api/backend';

export default {
  name: 'Menu',
  data() {
    return {
      profile: {},
      client: {},
    };
  },
  created() {
    this.getProfile()
    this.getClient()
  },
  methods: {

    getProfile() {
      http.post('application.get-profile')
        .then(response => {
          this.profile = response.data;
        })
    },

    getClient() {
      http.post('application.get-client')
        .then(response => {
          this.client = response.data
        })
    },

    logout() {
      http.post('application.logout')
        .then(response => {
            localStorage.removeItem('access_token')
            this.$router.push({ path: '/' })
            this.$toasted.show('Deslogado com sucesso.', {
              theme: 'outline',
              position: 'bottom-right',
              duration: 2000,
              type: 'success',
              icon: 'check_circle'
            });
        })
    },
    config() {
      setTimeout(() => {
        this.$router.push({ path: '/config/perfil' })
      }, 200)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/client/public/Menu.vue